module.exports = __webpack_public_path__ + "solution-build/img/featured-1@2.8e35fb8a.jpg";